import React from "react";

function Diamond() {
  return (
    <svg viewBox="0 0 24 24" className="w-4 h-4 shrink-0" fill="#ff6a2b">
      <path d="M12 2 L15 12 L12 22 L9 12 Z" />
      <path d="M2 12 L12 9 L22 12 L12 15 Z" />
    </svg>
  );
}

export default function BrandsMarquee({ brands = [] }) {
  const items = [...brands, ...brands];
  return (
    <section className="relative bg-black border-y border-white/5 py-10 overflow-hidden">
      <div className="marquee-track flex gap-14 items-center whitespace-nowrap w-max">
        {items.map((b, i) => (
          <div key={i} className="flex items-center gap-14">
            <span className="font-heading text-2xl md:text-4xl lg:text-5xl tracking-[0.08em] text-white/25 hover:text-white/60 transition-colors">
              {b.toUpperCase()}
            </span>
            <Diamond />
          </div>
        ))}
      </div>
    </section>
  );
}
